import _get from 'lodash/get';
import { helpingMethod } from '../../../utils/HelpingMethod';

const LubricationChartsApiParser: any = {};

LubricationChartsApiParser.LubricationChartsListParser = (res: any) => {
  if (!res) return [];

  const data = res?.data?.content?.map((item: any) => {
    const rawLastUpdated = _get(item, 'lastUpdated', null);
    const formattedLastUpdated = rawLastUpdated ? helpingMethod.formatDate(rawLastUpdated) : null;
    return {
      vessel: _get(item, 'vesselName', '-'),
      manager: _get(item, 'managerName', '-'),
      activeProducts: _get(item, 'activeProducts', 0),
      typeInProduct: _get(item, 'typeInProducts', 0),
      inactiveProducts: _get(item, 'inactiveProducts', 0),
      lastUpdatedBy: _get(item, 'updatedBy', '-'),
      lastUpdatedDate: formattedLastUpdated,
      vesselId: _get(item, 'vesselId', null),
    };
  });
  return data;
};

LubricationChartsApiParser.productsParser = (res: any) => {
  if (!res) return [];

  const data = res?.data?.content?.map((item: any) => {
    const rawUpdatedOn = _get(item, 'updatedOn', null);
    const formattedUpdatedOn = rawUpdatedOn ? helpingMethod.formatDate(rawUpdatedOn) : null;
    return {
      id: _get(item, 'productId', null),
      productName: _get(item, 'productName', '-'),
      maker: _get(item, 'makerName', '-'),
      category: _get(item, 'categoryName', '-'),
      type: _get(item, 'typeName', '-') === '' ? '-' : _get(item, 'typeName', '-'),
      unit: _get(item, 'unitName', '-'),
      status: _get(item, 'active', null) === true ? 'Active' : 'Inactive',
      typeInIndicator: _get(item, 'typeIn', '-') === true ? 'Type-in Product' : '-',
      updatedBy: _get(item, 'updatedBy', '-'),
      updatedOn: formattedUpdatedOn,
    };
  });
  return data;
};

export default LubricationChartsApiParser;
